// extracted by css-extract-rspack-plugin
export default {"card":"OverviewSection_card__or9ZX","section-title":"OverviewSection_section-title__pssXN","overview-item-wrap":"OverviewSection_overview-item-wrap__HizA3"};